import { inject, Injectable } from '@angular/core';

import { AnalyticsBase, GlobalAnalyticsContext } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class HrAssistantAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'HrAssistant';
  public readonly requireViewContext = false;
  public globalContext = inject(GlobalAnalyticsContext);

  public trackPublish(isEnabled: boolean): void {
    this.track('Publish', { enabled: isEnabled });
  }

  public trackTriggerClick(): void {
    this.track('Triggered', { context: this.globalContext.getFlatContext() });
  }

  public trackQuestionAsked(isConversationStarter: boolean, threadId: string) {
    this.track('QuestionAsked', {
      isConversationStarter,
      threadId,
      context: this.globalContext.getFlatContext(),
    });
  }

  public conversationStarterAdded() {
    this.track('ConversationStarterAdded');
  }

  public responseRated(rating: 'up' | 'down', threadId: string): void {
    this.track('ResponseRated', { rating, threadId });
  }
}
